var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { GetRescheduleSlotsAPI, GetRescheduleSlotsGuestAPI, } from '../../../api/rms/reschedules';
import { getWindow } from '../../../utils/general';
import { makeGuestRequestBody } from '../../../utils/guest-order-tracking-utils';
import { getGuestOrderTracking } from '../../../api/oms/guest-order-tracking';
export var getAvailableSlots = function (orderDetailsData, fulfillmentGroup) {
    var orderNumber = orderDetailsData.orderNumber, emailId = orderDetailsData.emailId, orderDetailsEt = orderDetailsData.et, net = orderDetailsData.net;
    var lineItems = fulfillmentGroup.lineItems, bodfsDeliveryAndHandling = fulfillmentGroup.bodfsDeliveryAndHandling, fulfillmentType = fulfillmentGroup.fulfillmentType, fulfillmentEt = fulfillmentGroup.et;
    var requestData;
    var et = fulfillmentEt !== null && fulfillmentEt !== void 0 ? fulfillmentEt : orderDetailsEt;
    if (!et) {
        et = orderDetailsData.et;
    }
    if (bodfsDeliveryAndHandling === null || bodfsDeliveryAndHandling === void 0 ? void 0 : bodfsDeliveryAndHandling.bodfsDeliveries) {
        var bodfsDeliveries = bodfsDeliveryAndHandling.bodfsDeliveries;
        var _a = bodfsDeliveries[0], deliveryAddress = _a.deliveryAddress, deliveryTimeSlotType = _a.deliveryTimeSlotType;
        var postalDetails = deliveryAddress.postalDetails;
        var _b = postalDetails, addressLine1 = _b.addressLine1, addressLine2 = _b.addressLine2, city = _b.city, state = _b.state, zipCode_1 = _b.zipCode, country = _b.country;
        var items_1 = [];
        var lineIds_1 = [];
        lineItems === null || lineItems === void 0 ? void 0 : lineItems.map(function (el) {
            var _a, _b, _c, _d, _e, _f;
            lineIds_1.push((_a = el === null || el === void 0 ? void 0 : el.lineId) !== null && _a !== void 0 ? _a : '');
            return items_1.push({
                lineId: el.lineId,
                productId: (_c = ((_b = el === null || el === void 0 ? void 0 : el.omsId) !== null && _b !== void 0 ? _b : '').toString()) !== null && _c !== void 0 ? _c : ((_d = el === null || el === void 0 ? void 0 : el.secOmsId) !== null && _d !== void 0 ? _d : '').toString(),
                sku: ((_e = el === null || el === void 0 ? void 0 : el.skuNumber) !== null && _e !== void 0 ? _e : '').toString(),
                price: el.totalPrice,
                quantity: (_f = el.workOrderFulfilledQty) !== null && _f !== void 0 ? _f : el.currentQuantity,
                deliveryZipCode: zipCode_1,
            });
        });
        requestData = {
            dfsAvailableDeliverySlotsRequest: __assign(__assign({ orderId: orderNumber, emailId: emailId, et: et, items: items_1, net: net }, (orderDetailsData.sellingLocation && {
                sellingLocation: orderDetailsData.sellingLocation,
            })), { deliverySlotType: deliveryTimeSlotType, fulfillmentOptions: [
                    {
                        lineIds: lineIds_1,
                        fulfillmentAddress: {
                            addressLine1: addressLine1,
                            addressLine2: addressLine2 || null,
                            city: city,
                            state: state,
                            zipCode: zipCode_1,
                            country: country,
                        },
                    },
                ] }),
        };
    }
    if (fulfillmentType === 'Appliance') {
        requestData = {
            applianceAvailableDeliverySlotsRequest: {
                orderId: orderNumber,
                emailId: emailId,
                et: et,
                net: net,
            },
        };
    }
    return requestData;
};
export var getApiData = function (orderDetailsData, fulfillmentGroup, setAvailableSlotsData, setOpen, setLoading, setAvailableSlotsError) {
    var _a, _b, _c, _d, _e, _f;
    (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage) === null || _b === void 0 ? void 0 : _b.removeItem('bannerState');
    setLoading(true);
    var isBodfsOrDfs = fulfillmentGroup.fulfillmentType === 'BuyOnlineDeliverFromStore' ||
        fulfillmentGroup.fulfillmentType === 'DFS';
    var targetFulfillmentGroup = orderDetailsData.fulfillmentGroups.find(function (group) { return group.fulfillmentType === fulfillmentGroup.fulfillmentType; });
    var sellingLocation = isBodfsOrDfs
        ? (_e = (_d = (_c = targetFulfillmentGroup === null || targetFulfillmentGroup === void 0 ? void 0 : targetFulfillmentGroup.bodfsDeliveryAndHandling) === null || _c === void 0 ? void 0 : _c.bodfsDeliveries) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.storeId
        : undefined;
    var modifiedOrderDetailsData = __assign(__assign({}, orderDetailsData), { sellingLocation: isBodfsOrDfs ? sellingLocation : undefined });
    return GetRescheduleSlotsAPI(getAvailableSlots(isBodfsOrDfs ? modifiedOrderDetailsData : orderDetailsData, fulfillmentGroup), (_f = orderDetailsData.traceId) !== null && _f !== void 0 ? _f : '')
        .then(function (res) {
        setAvailableSlotsData(res.data);
        setLoading(false);
        setAvailableSlotsError(false);
        setOpen(true);
    })
        .catch(function () {
        setLoading(false);
        setAvailableSlotsError(true);
    });
};
export var handleGuestUserReschedule = function (orderDetailsData, fulfillmentGroup, setAvailableSlotsData, setOpen, setLoading, setAvailableSlotsError) {
    var _a, _b, _c, _d, _e;
    (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage) === null || _b === void 0 ? void 0 : _b.removeItem('bannerState');
    setLoading(true);
    var orderNumber = (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber) || '';
    var emailId = (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId) || '';
    var custPhone = (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.custPhone) || '';
    var requestToken = makeGuestRequestBody(orderNumber, emailId, custPhone);
    var isBodfsOrDfs = fulfillmentGroup.fulfillmentType === 'BuyOnlineDeliverFromStore' ||
        fulfillmentGroup.fulfillmentType === 'DFS';
    var targetFulfillmentGroup = orderDetailsData.fulfillmentGroups.find(function (group) { return group.fulfillmentType === fulfillmentGroup.fulfillmentType; });
    var sellingLocation = isBodfsOrDfs
        ? (_e = (_d = (_c = targetFulfillmentGroup === null || targetFulfillmentGroup === void 0 ? void 0 : targetFulfillmentGroup.bodfsDeliveryAndHandling) === null || _c === void 0 ? void 0 : _c.bodfsDeliveries) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.storeId
        : undefined;
    var modifiedOrderDetailsData = __assign(__assign({}, orderDetailsData), { sellingLocation: isBodfsOrDfs ? sellingLocation : undefined });
    return getGuestOrderTracking(requestToken)
        .then(function (response) {
        var _a;
        var token = response.data.xAuthGuestToken;
        return GetRescheduleSlotsGuestAPI(getAvailableSlots(isBodfsOrDfs ? modifiedOrderDetailsData : orderDetailsData, fulfillmentGroup), token, (_a = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId) !== null && _a !== void 0 ? _a : '');
    })
        .then(function (res) {
        setAvailableSlotsData(res.data);
        setLoading(false);
        setAvailableSlotsError(false);
        setOpen(true);
    })
        .catch(function () {
        setLoading(false);
        setAvailableSlotsError(true);
    });
};
